export default __webpack_public_path__ + "static/media/ic_copy.69859a27.svg";